<template>
    <div class="mx-2  pt-2 py-2">
        <h1 class="flex justify-center text-2xl 100vh  mb-5 pt-10 ">Update Role</h1>
        <form class="max-w-md mx-auto" @submit.prevent="submit">
            <div class="mb-5">
                <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Role Name</label>
                <input type="text" v-model="role" id="username"
                    class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                    placeholder="Role Name" />
            </div>
            <div class="mb-5">
                <label for="number" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Session Time (in minutes)</label>
                <input type="text" v-model="session_time" id="session_time"
                    class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                    placeholder="Session Time" />
            </div>
            <h3 class="mb-4 font-semibold text-gray-900 dark:text-white">Permissions</h3>
            <ul v-for="perm in permissions" :key="perm.id"
                class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                    <div class="flex items-center ps-3">
                        <input :id="'vue-checkbox-list-' + perm.id" v-model="permissionid"
                            :checked="permissionid.includes(perm.id)" :value="perm.id" type="checkbox"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                        <label :for="'vue-checkbox-list-' + perm.id"
                            class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{ perm.name
                            }}</label>
                    </div>
                </li>
            </ul>

            <div class="flex items-center mt-5 justify-center">
                <router-link to="role"
                    class="text-white mb-5  bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Back</router-link>
                <button type="submit"
                    class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Update Role</button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import Swal from 'sweetalert2';
import axiosInstce from "@/plugins/axios"
import { useRouter } from 'vue-router';
import { useAuthService } from '@/store/Auth'; //  auth.js file

const authStore = useAuthService();

const router = useRouter(); // Initialize the router object

const permissions = ref()
const permissionid = ref([])
const session_time = ref()
const roleId = ref()
const role = ref()
const getPermission = () => {
    axiosInstce.get(`/permissions`)
        .then(response => {
            permissions.value = response.data.data.permissions
        })
        .catch(error => {
            console.error('Error fetching hospitals:', error);
        });
}
const getrole = () => {
    axiosInstce.get(`/get-role/${roleId.value}`)
        .then(response => {
            role.value = response.data.data.role.name
            permissionid.value = response.data.data.role.permissions.map(perm => perm.id);
            session_time.value = response.data.data.role.session_time

        })
        .catch(error => {
            console.error('Error fetching hospitals:', error);
        });
}
const submit = async () => {

    try {
        const response = await axiosInstce.put(`/roles/${roleId.value}`, {
            role_name: role.value,
            permissions: permissionid.value,
            session_time: session_time.value
        });
        Swal.fire({
            toast: true,
            title: 'Role created successfully.',
            icon: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        router.push({ name: 'role' });
    } catch (error) {
        console.error('Error fetching Role info:', error);
        Swal.fire({
            toast: true,
            title: error.response.data.message,
            icon: 'error',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
    }
    // form.value = '';

};
onMounted(() => {
    const id = router.currentRoute.value.params.id;
    roleId.value = id
    getPermission()
    getrole()
})
onMounted(async () => {
    await authStore.handlepermission()
})

onUnmounted(async () => {
    await authStore.handlepermission()
})
</script>